import { useEffect } from "react";
const FeedbackScroll = () => {
  useEffect(() => {
    const first = document.querySelector("#first-move");
    const second = document.querySelector("#second-move");
    const third = document.querySelector("#third-move");
    const animate = (element, position) => {
      element.style.transform = `translateX(${position}px)`;
    };
    let lastKnownScrollPosition;
    document.addEventListener("scroll", function () {
      lastKnownScrollPosition = window.scrollY;
      window.requestAnimationFrame(function () {
        animate(first, lastKnownScrollPosition * 0.8);
        animate(second, lastKnownScrollPosition * -0.8);
        animate(third, lastKnownScrollPosition * 0.8);
      });
    });
  }, []);

  return (
    <>
      <div className="overflow-hidden pt-8 md:pt-16">
        <div
          className="overflow-hidden h-[20vh] w-[1930vw] md:w-[1120vw] md:h-[45vh] xl:h-[70vh] xl:w-[650vw]"
          id="containermove"
        >
          <h1
            className="transition-transform duration-200 ease-linear text-5xl md:text-8xl xl:text-large font-normal text-black -ml-[398rem] md:-ml-[400rem] xl:-ml-[410rem] xl:leading-tight"
            id="first-move"
          >
            <span className="font-jomolhari inline-block">CLIENT LOVED</span>
          </h1>
          <h1
            className="transition-transform duration-200 ease-linear text-5xl md:text-8xl xl:text-large font-normal text-black text-center ml-[300rem] md:ml-[330rem] xl:ml-[350rem] xl:leading-tight"
            id="second-move"
          >
            <span className="font-jomolhari inline-block">THE OVERALL</span>
          </h1>
          <h1
            className="transition-transform duration-200 ease-linear text-5xl md:text-8xl xl:text-large font-normal text-black -ml-[398rem] md:-ml-[400rem] xl:-ml-[410rem] xl:leading-tight"
            id="third-move"
          >
            <span className="font-jomolhari inline-block">PROJECT</span>
          </h1>
        </div>
      </div>
    </>
  );
};

export default FeedbackScroll;
